import React, { useContext, useRef } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import MerchandiseRemittanceGrid from './MerchandiseRemittanceGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles } from '@material-ui/core';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import { commonFilter } from '../../constants/StyleConstants';
import useMerchandiseRemittancePresenter from './MerchandiseRemittancePresenter';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';

const useStyles = makeStyles(theme => {
  return {
    ...commonFilter,
  };
});

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const { selectedSupplier, setSelectedSupplier, dateFrom, setDateFrom, dateTo, setDateTo, validateAndSearch, cleanFilters } = filtersProps;

  return (
    <div className={classes.filters}>
      {!isSupplier && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}
      <CustomDatePicker value={dateFrom} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker value={dateTo} label="Fecha hasta" setValue={setDateTo} />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const MerchandiseRemittance = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const { firstLoad, rows, loading, ...filtersProps } = useMerchandiseRemittancePresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
        <MerchandiseRemittanceGrid data={rows} tableRef={tableRef} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};
export default MerchandiseRemittance;
